import { WHATSAPP } from '../../constants';
import './needs.css';

const needs = [
  { key: 'blanquear_ropa', emoji: '👕', label: 'Quiero blanquear ropa', desc: 'Ropa blanca opaca, manchas amarillas, devolverle el brillo.' },
  { key: 'sacar_manchas', emoji: '🩸', label: 'Quiero sacar manchas', desc: 'Manchas de comida, grasa, vino, sangre o pasto en la ropa.' },
  { key: 'limpiar_bano', emoji: '🚿', label: 'Quiero limpiar el baño', desc: 'Sarro, moho, cal en azulejos, grifería y sanitarios.' },
  { key: 'desengrasar_cocina', emoji: '🍳', label: 'Quiero desengrasar cocina', desc: 'Campana, horno, mesada, hornallas. Grasa difícil sin químicos.' },
  { key: 'sacar_olores', emoji: '🌬️', label: 'Quiero sacar olores', desc: 'Olores de mascotas, humedad, cocina, ambientes cerrados.' },
  { key: 'empezar', emoji: '🌱', label: 'Quiero empezar con limpieza sustentable', desc: 'No sé por dónde arrancar. Guiame con lo básico.' },
];

function Needs() {
  return (
    <section id="needs" className="section needs">
      <div className="container">
        <div className="needs__header">
          <span className="section-label">¿Qué necesitás?</span>
          <h2 className="section-title">Decinos qué querés limpiar y te recomendamos</h2>
          <p className="section-subtitle">Elegí tu necesidad y te asesoramos al toque por WhatsApp.</p>
        </div>
        <div className="needs__grid">
          {needs.map((n) => (
            <a
              key={n.key}
              href={WHATSAPP.need(n.key)}
              target="_blank"
              rel="noreferrer"
              className="card needs__card"
            >
              <span className="needs__emoji">{n.emoji}</span>
              <div>
                <h3 className="needs__label">{n.label}</h3>
                <p className="needs__desc">{n.desc}</p>
              </div>
              <span className="needs__arrow">→</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Needs;
